import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Check } from 'lucide-react';

const QualificationsPage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="qualifications-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Qualifications
        </h1>

        {/* Introduction */}
        <section className="mb-10" data-testid="qualifications-intro">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Freemasonry, in lodges under the auspices of the Grand Lodge of Scotland, is open to any 
            man able to profess a belief in a Supreme Being and who demonstrates high moral values.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Whilst not a requirement, many candidates for admission to St. David (University Lodge) No. 36 
            have a connection with a Scottish university.
          </p>
        </section>

        {/* Dispensations */}
        <section className="mb-10" data-testid="dispensations-section">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">
            University Lodge Scheme Dispensations
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Under the Scottish University Lodge Scheme, our lodge enjoys certain dispensations:
          </p>
          
          <div className="space-y-4">
            <Card className="border-gray-100 border-l-4 border-l-emerald-500" data-testid="dispensation-age">
              <CardContent className="p-4 flex items-start gap-4">
                <div className="h-8 w-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Check className="h-5 w-5 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Age Requirement</h3>
                  <p className="text-gray-600">
                    To waive the normal age requirement of 21 years and regularly admits candidates from 
                    the age of 18.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-gray-100 border-l-4 border-l-emerald-500" data-testid="dispensation-residency">
              <CardContent className="p-4 flex items-start gap-4">
                <div className="h-8 w-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Check className="h-5 w-5 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Residency Requirement</h3>
                  <p className="text-gray-600">
                    To admit candidates who have not been ordinarily resident in the vicinity of the lodge 
                    for a period of three years.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-gray-100 border-l-4 border-l-emerald-500" data-testid="dispensation-fee">
              <CardContent className="p-4 flex items-start gap-4">
                <div className="h-8 w-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                  <Check className="h-5 w-5 text-emerald-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Reduced Fees</h3>
                  <p className="text-gray-600">
                    To reduce by half the joining fee for a candidate in full-time education.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Call to Action */}
        <section data-testid="cta-section">
          <Card className="bg-gradient-to-br from-gray-50 to-white border-gray-100">
            <CardContent className="p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-gray-900 mb-3">
                Interested in Joining?
              </h3>
              <p className="text-gray-700 mb-4">
                If you meet the qualifications and are interested in becoming a member, please visit our 
                Contact page or attend one of our regular meetings.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md font-medium transition-colors"
                data-testid="contact-cta"
              >
                Contact Us
              </a>
            </CardContent>
          </Card>
        </section>
      </div>
    </div>
  );
};

export default QualificationsPage;
